import React from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ListIcon from '@material-ui/icons/List';
import MoreIcon from "@material-ui/icons/MoreVert";
import { useHistory } from "react-router-dom";
import { getFlag, getPods } from "../../util/host";
import { Avatar, Chip } from "@material-ui/core";
import axios from "axios";
import { baseUrl, getCurrentUser,removeFromCookie } from "../../util/host";
import Sidebar from "./Sidebar";
import { useSidebar } from "../../contexts/SidebarContext";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'fixed',
    width: '100%',
    zIndex: theme.zIndex.drawer + 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  contentShift: {
    marginLeft: 324,  
    transition: "margin 0.3s ease",
  },
  content: {
    transition: "margin 0.3s ease",
    minHeight: "calc(100vh - 64px)",
    padding: theme.spacing(3),
    backgroundColor: "#f5f5f5",
    marginLeft: 74, // Default margin for closed sidebar
  },
  contentWrapper: {
    marginTop: 64, // Height of the toolbar
  },
}));

export default function AddressMapperToolbar() {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const { isMainDrawerOpen, setIsMainDrawerOpen, toggleDrawer } = useSidebar();
  
  const isGulf = localStorage.getItem("region") === "GULF";

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleDrawerToggle = () => {
    console.log('toogle clicked', isMainDrawerOpen)
    toggleDrawer();
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const logout = async() => {
    const user = getCurrentUser();
    if(user){
      const {uuid, token} = user;
      const result = await axios.post(`${baseUrl("REACT_APP_AUTH_SERVICE_URL")}/logout`,
      {
        uuid
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token?.trim() || ''}`,
        }
      });
      console.log('resultLogout:::', result.data);
      if(result.data.status){
        localStorage.clear();
        removeFromCookie();
        // history.push("/login");
        window.location.replace("/login");
        setTimeout(() => {
          window.location.reload();
        }, 200);
      }
    }
    setIsMainDrawerOpen(false)
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handlePublishHistory = () => {
    history.push("/publish/activity");
    setAnchorEl(null);
    handleMobileMenuClose();
    setIsMainDrawerOpen(false)
  };

  const handleDeliveryPayment = () => {
    history.push("/delivery/payment");
    setAnchorEl(null);
    handleMobileMenuClose();
    setIsMainDrawerOpen(false)
  }

  const handleSellerLocation = () => {
    history.push("/location/sellerLocation");
    setAnchorEl(null);
    handleMobileMenuClose();
    setIsMainDrawerOpen(false)
  };

   const handleFulfilmentLocation = () => {
    history.push("/location/fulfillmentLocation");
    setAnchorEl(null);
    handleMobileMenuClose();
    setIsMainDrawerOpen(false)
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handlePublishHistory}>Publish Activity</MenuItem>
      {isGulf ? (
        <MenuItem onClick={handleDeliveryPayment}>
          Choose Payment Methods
        </MenuItem>
      ) : (
        <></>
      )}

      <MenuItem onClick={logout}>Log out</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Settings</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <ListIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            Address Mapper
          </Typography>
          <div className={classes.grow} />
          <Chip
            color="success" 
            avatar={<Avatar alt="Natacha" src={getFlag()} />}
            label={getPods()}
          />
          <div className={classes.sectionDesktop}>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>

      <Sidebar
        isMainDrawerOpen={isMainDrawerOpen}
        setIsMainDrawerOpen={setIsMainDrawerOpen}
        handlePublishHistory={handlePublishHistory}
        handleDeliveryPayment={handleDeliveryPayment}
        handleSellerLocation={handleSellerLocation}
        handleFulfilmentLocation={handleFulfilmentLocation}
        logout={logout}
      />

      {renderMobileMenu}
      {renderMenu}
    </>
  );
}
